import { lazy } from 'react';

export const AuthForgotPasswordVerificationScreenLazy = lazy(async () => {
  const { AuthForgotPasswordVerifyScreen } = await import('./auth-forgot-password-verify.screen.tsx');
  return { default: AuthForgotPasswordVerifyScreen };
});
